import type { SxProps } from "@mui/material"

const rowContainer: (isSelected?: boolean) => SxProps = (
  isSelected?: boolean
) => ({
  width: "100%",
  height: "2rem",
  cursor: "pointer",
  px: 1,
  background: isSelected ? "white" : "transparent",
  borderRadius: 1,
  ":hover": {
    background: "white"
  }
})

const rowText: SxProps = {
  color: "#4E4E4E",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  display: "block",
  fontSize: 14
}

export default { rowText, rowContainer }
